// var htmlContent = require('./TAC_content.htm');
import { htmlContent } from './TAC_content';

export const TAC = () => {
    return (
        <>
            <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
            <div style={{height: "5vh"}} ></div>
        </>
    )
}